import { useEffect, useMemo, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  fruitBaskets,
  getProduct,
  images,
  initialAddresses,
  products,
  serviceAreas,
  shakeProducts,
  timeSlots,
  weekdays,
} from "../data";
import { useApp } from "../store";
import {
  AddressCard,
  Brand,
  DeliveryCard,
  EmptyState,
  PageHeader,
  PrimaryButton,
  ProductCard,
  StatusBadge,
} from "../components/UI";

import "../css/Splash.css";
export function Splash() {
  const navigate = useNavigate();
  const [slide, setSlide] = useState(() =>
    localStorage.getItem("freshloop_onboarded") ? -1 : 0,
  );
  useEffect(() => {
    if (slide === -1) {
      const timer = setTimeout(() => navigate("/home"), 1300);
      return () => clearTimeout(timer);
    }
  }, [slide, navigate]);
  const slides = [
    {
      icon: "fa-basket-shopping",
      title: "Fresh, not stored",
      body: "We buy your fruits fresh from the nearby market instead of keeping large inventory.",
      image: images.large_basket,
      type: "fruite_basket",
    },
    {
      icon: "fa-glass-water",
      title: "Your protein, on schedule",
      body: "A vibrant, beetroot-rich fresh juice blended with ginger, lemon juice and a spoon of honey. Naturally earthy, tangy and lightly sweet, served chilled.",
      image: images.beetroot_juice,
      type: "protein_shake",
    },
    {
      icon: "fa-calendar-check",
      title: "Set it once. Forget it.",
      body: "Schedule daily, weekly or multiple deliveries and we’ll take care of the rest.",
      image: images.fruit,
      type: "fruite_basket",
    },
    {
      icon: "fa-glass-water",
      title: "FreshLoop Alkaline Water",
      body: "Refreshing infused water prepared with cucumber, mint leaves, beetroot, lemon, coriander leaves, carrot, amla, fresh ginger and chia seeds. Soaked for 12 hours to infuse the water with fresh, earthy, citrus and herbal flavours. Serve chilled.",
      image: images.alkaline_water,
      type: "protein_shake",
    },
  ];
  const finish = () => {
    localStorage.setItem("freshloop_onboarded", "true");
    navigate("/home");
  };
  if (slide === -1)
    return (
      <div className="splash">
        <div className="splash-orb" />
        <Brand light />
        <div>
          <span className="eyebrow text-white-50">Fresh delivery, Pune</span>
          <h1>
            Schedule it.
            <br />
            We bring it fresh.
          </h1>
          <p>Fresh nutrition & fruits, delivered on your schedule.</p>
        </div>
        <div className="splash-loader">
          <span />
        </div>
      </div>
    );
  const current = slides[slide];
  return (
    <div className="onboarding">
      <button className="skip-link" onClick={finish}>
        Skip
      </button>
      <div
        className={`onboarding-image ${current.type === "protein_shake" ? "onboarding-image-juice" : ""}`}
      >
        <img src={current.image} alt="" />
        <div className="onboarding-icon">
          <i className={`fa-solid ${current.icon}`} />
        </div>
      </div>
      <div
        className={`onboarding-copy ${current.type === "protein_shake" ? "onboarding-copy-juice" : ""}`}
      >
        <div className="dots">
          {slides.map((_, i) => (
            <span key={i} className={i === slide ? "active" : ""} />
          ))}
        </div>
        <h1>{current.title}</h1>
        <p>{current.body}</p>
        <PrimaryButton
          className="w-100 btn-lg"
          icon="fa-arrow-right"
          onClick={() => (slide < 3 ? setSlide(slide + 1) : finish())}
        >
          {slide === 2 ? "Get Started" : "Continue"}
        </PrimaryButton>
      </div>
    </div>
  );
}

export default Splash;
